/* GYMBRAT - theme.js v2 */
(() => {
  'use strict';

  /* Drawers */
  const getDrawers = () => document.querySelectorAll('.drawer');
  const openDrawer = (id) => {
    const d = document.getElementById(id);
    if (!d) return;
    d.setAttribute('aria-hidden','false');
    d.classList.add('is-open');
    document.body.style.overflow='hidden';
    if (id === 'SearchDrawer') {
      const input = d.querySelector('#SearchDrawerInput');
      setTimeout(() => input?.focus(), 30);
    }
  };
  const closeAll = () => {
    getDrawers().forEach(d => {
      d.setAttribute('aria-hidden','true');
      d.classList.remove('is-open');
    });
    document.body.style.overflow='';
  };
  const setCartCount = (cart) => {
    const count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = String(count).padStart(2,'0');
    });
  };
  const formatMoney = (cents, currency) => {
    const amount = (Number(cents || 0) / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return currency === 'INR' ? 'Rs. ' + amount : amount;
  };
  const getCartDrawerParts = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return null;
    return {
      drawer,
      items: drawer.querySelector('[data-cart-items]'),
      footer: drawer.querySelector('[data-cart-footer]'),
      subtotal: drawer.querySelector('[data-cart-subtotal]'),
      template: document.querySelector('[data-cart-item-template]')
    };
  };
  const renderCartDrawer = (cart) => {
    const parts = getCartDrawerParts();
    if (!parts || !parts.items || !parts.template) return;

    setCartCount(cart);
    parts.items.innerHTML = '';

    if (!cart.items.length) {
      const empty = document.createElement('p');
      empty.className = 'gb-cart-drawer__empty cart-drawer__empty';
      empty.textContent = 'Your cart is empty.';
      parts.items.append(empty);
      if (parts.footer) parts.footer.hidden = true;
      return;
    }

    cart.items.forEach((item) => {
      const node = parts.template.content.firstElementChild.cloneNode(true);
      const link = node.querySelector('[data-cart-item-url]');
      const image = node.querySelector('[data-cart-item-image]');
      const title = node.querySelector('[data-cart-item-title]');
      const variant = node.querySelector('[data-cart-item-variant]');
      const quantity = node.querySelector('[data-cart-item-quantity]');
      const price = node.querySelector('[data-cart-item-price]');
      const decrease = node.querySelector('[data-cart-decrease]');
      const increase = node.querySelector('[data-cart-increase]');
      const remove = node.querySelector('[data-cart-remove]');

      if (link) link.href = item.url;
      if (image) {
        image.src = item.image ? item.image + '&width=192' : '';
        image.alt = item.product_title || '';
        image.hidden = !item.image;
      }
      if (title) {
        title.href = item.url;
        title.textContent = item.product_title || item.title || '';
      }
      if (variant) {
        const hasVariant = item.variant_title && item.variant_title !== 'Default Title';
        variant.textContent = hasVariant ? item.variant_title : '';
        variant.hidden = !hasVariant;
      }
      if (quantity) quantity.textContent = item.quantity;
      if (price) price.textContent = formatMoney(item.final_line_price, cart.currency);

      const changeQuantity = async (nextQuantity) => {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: Math.max(0, nextQuantity) })
        });
        await refreshCartDrawer();
      };

      decrease?.addEventListener('click', () => changeQuantity(item.quantity - 1));
      increase?.addEventListener('click', () => changeQuantity(item.quantity + 1));
      remove?.addEventListener('click', () => changeQuantity(0));

      parts.items.append(node);
    });

    if (parts.subtotal) parts.subtotal.textContent = formatMoney(cart.total_price, cart.currency);
    if (parts.footer) parts.footer.hidden = false;
  };
  const refreshCartDrawer = async () => {
    const cart = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(x => x.json());
    renderCartDrawer(cart);
    return cart;
  };
  window.gbCartRefresh = refreshCartDrawer;
  const showCartToast = (message) => {
    let toast = document.querySelector('.gb-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'gb-cart-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    window.clearTimeout(showCartToast.timer);
    showCartToast.timer = window.setTimeout(() => toast.remove(), 2600);
  };

  document.addEventListener('click', async (e) => {
    const cartOpen = e.target.closest('[data-cart-open]');
    if (cartOpen) {
      e.preventDefault();
      e.stopPropagation();
      closeAll();
      try {
        await refreshCartDrawer();
      } catch (_) {}
      openDrawer('CartDrawer');
      return;
    }

    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeAll();
      return;
    }

    const toggle = e.target.closest('[data-drawer-toggle]');
    if (toggle) { e.preventDefault(); const id = toggle.getAttribute('data-drawer-toggle'); const d = document.getElementById(id); if (d.getAttribute('aria-hidden') === 'false') closeAll(); else { closeAll(); openDrawer(id); } return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeAll(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* Gender tab menu */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-menu-tab]');
    if (!tab) return;
    const drawer = tab.closest('.gb-mobile-menu');
    if (!drawer) return;
    const target = tab.getAttribute('data-menu-tab');
    drawer.querySelectorAll('[data-menu-tab]').forEach((button) => {
      const active = button === tab;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    drawer.querySelectorAll('[data-menu-panel]').forEach((panel) => {
      const active = panel.getAttribute('data-menu-panel') === target;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  });

  /* PDP size chart */
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-size-chart-open]');
    if (open) {
      const root = open.closest('[data-size-chart]');
      const modal = root?.querySelector('[data-size-chart-modal]');
      if (modal) {
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      return;
    }
    const close = e.target.closest('[data-size-chart-close]');
    if (close) {
      const modal = close.closest('[data-size-chart-modal]');
      if (modal) {
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }
  });

  /* Predictive search suggestions */
  (() => {
    const drawer = document.getElementById('SearchDrawer');
    if (!drawer) return;
    const input = drawer.querySelector('#SearchDrawerInput');
    const list = drawer.querySelector('[data-search-suggestions]');
    const hint = drawer.querySelector('[data-search-hint]');
    if (!input || !list || !hint) return;

    let timer = null;
    let controller = null;

    const htmlEscape = (value) => String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

    const renderEmpty = (message) => {
      list.innerHTML = '';
      hint.hidden = false;
      hint.textContent = message;
    };

    const renderResults = (data, query) => {
      const results = data?.resources?.results || {};
      const products = results.products || [];
      const collections = results.collections || [];
      const rows = [];

      collections.slice(0, 2).forEach((collection) => {
        rows.push({
          title: collection.title,
          url: collection.url
        });
      });

      products.slice(0, 6).forEach((product) => {
        rows.push({
          title: product.title,
          url: product.url
        });
      });

      if (!rows.length) {
        renderEmpty('No suggestions. Press Enter to search "' + query + '".');
        return;
      }

      hint.hidden = true;
      list.innerHTML = rows.map((row) => {
        return '<li><a class="search-drawer__suggestion" href="' + htmlEscape(row.url) + '"><strong>' + htmlEscape(row.title) + '</strong></a></li>';
      }).join('');
    };

    const fetchSuggestions = async (query) => {
      const q = query.trim();
      if (!q) {
        renderEmpty('Start typing to see suggestions.');
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();

      try {
        const url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last';
        const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('suggest failed');
        const data = await response.json();
        renderResults(data, q);
      } catch (error) {
        if (error.name === 'AbortError') return;
        renderEmpty('Press Enter to search "' + q + '".');
      }
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(() => fetchSuggestions(input.value), 140);
    });

    input.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      const first = list.querySelector('a');
      if (first && input.value.trim()) {
        e.preventDefault();
        window.location.href = first.href;
      }
    });
  })();

  /* Collection load more */
  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest('[data-load-more] [data-next-url]');
    if (!trigger) return;
    const grid = document.querySelector('[data-collection-grid]');
    const wrap = trigger.closest('[data-load-more]');
    if (!grid || !wrap) return;
    e.preventDefault();

    const nextUrl = trigger.getAttribute('data-next-url') || trigger.getAttribute('href');
    if (!nextUrl) return;

    const originalLabel = trigger.textContent;
    trigger.classList.add('is-loading');
    trigger.textContent = 'Loading';

    try {
      const html = await fetch(nextUrl, { headers: { 'Accept': 'text/html' } }).then(r => {
        if (!r.ok) throw new Error('load failed');
        return r.text();
      });
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextCards = doc.querySelectorAll('[data-collection-grid] > .card');
      nextCards.forEach(card => grid.insertBefore(card, wrap));

      const nextTrigger = doc.querySelector('[data-load-more] [data-next-url]');
      if (nextTrigger) {
        trigger.setAttribute('href', nextTrigger.getAttribute('href') || nextTrigger.getAttribute('data-next-url'));
        trigger.setAttribute('data-next-url', nextTrigger.getAttribute('data-next-url') || nextTrigger.getAttribute('href'));
        trigger.textContent = originalLabel;
        trigger.classList.remove('is-loading');
      } else {
        wrap.remove();
      }
    } catch (err) {
      window.location.href = nextUrl;
    }
  });

  /* Quantity steppers */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-step]'); if (!step) return;
    const wrap = step.closest('.qty'); if (!wrap) return;
    const input = wrap.querySelector('input');
    const dir = parseInt(step.getAttribute('data-qty-step'), 10);
    const next = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + dir);
    input.value = next; input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', async (e) => {
    const input = e.target.closest('#CartDrawer input[name="updates[]"]');
    if (!input) return;
    const form = input.closest('form');
    if (!form || form.dataset.gbCartUpdating === 'true') return;
    form.dataset.gbCartUpdating = 'true';
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      });
      if (!response.ok) throw new Error('cart update failed');
      const cart = await response.json();
      setCartCount(cart);
      await refreshCartDrawer();
      openDrawer('CartDrawer');
    } catch (err) {
      form.submit();
    } finally {
      if (form.isConnected) delete form.dataset.gbCartUpdating;
    }
  });

  document.addEventListener('click', async (e) => {
    const remove = e.target.closest('#CartDrawer [data-gb-cart-remove]');
    if (remove) {
      e.preventDefault();
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: remove.getAttribute('data-gb-cart-remove'), quantity: 0 })
        });
        if (!response.ok) throw new Error('cart remove failed');
        const cart = await response.json();
        setCartCount(cart);
        await refreshCartDrawer();
        openDrawer('CartDrawer');
      } catch (err) {
        window.location.href = remove.href;
      }
      return;
    }

    const coupon = e.target.closest('#CartDrawer [data-gb-cart-apply]');
    if (coupon) {
      e.preventDefault();
      const code = coupon.getAttribute('data-gb-cart-apply') || '';
      coupon.disabled = true;
      showCartToast('Applying ' + code + '.');
      try {
        await fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' });
        showCartToast(code + ' applied. Final discount is checked at checkout.');
        const cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(x => x.json());
        setCartCount(cart);
        await refreshCartDrawer();
        openDrawer('CartDrawer');
      } catch (err) {
        showCartToast('Could not apply ' + code + '. Please try again at checkout.');
      } finally {
        coupon.disabled = false;
      }
      return;
    }

    const coupons = e.target.closest('#CartDrawer [data-gb-cart-coupons]');
    if (coupons) {
      e.preventDefault();
      showCartToast('Available coupon: GYMBRAT199. Tap Apply to use it.');
    }
  });

  /* PDP looped swipe carousel */
  document.querySelectorAll('[data-pdp-loop-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-pdp-loop-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-pdp-loop-slide]'));
    if (!track || slides.length <= 1 || track.dataset.loopReady === 'true') return;
    track.dataset.loopReady = 'true';

    const firstClone = slides[0].cloneNode(true);
    const lastClone = slides[slides.length - 1].cloneNode(true);
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    firstClone.classList.add('is-clone');
    lastClone.classList.add('is-clone');
    track.insertBefore(lastClone, slides[0]);
    track.appendChild(firstClone);

    const realCount = slides.length;
    let active = 1;
    let scrollTimer = null;
    let settleTimer = null;
    let isInteracting = false;

    const slideWidth = () => track.clientWidth || carousel.clientWidth || 1;
    const jumpTo = (index, smooth) => {
      active = index;
      track.style.scrollBehavior = smooth ? 'smooth' : 'auto';
      track.scrollLeft = slideWidth() * index;
      if (!smooth) {
        requestAnimationFrame(() => {
          track.style.scrollBehavior = 'smooth';
        });
      }
    };

    const normalize = () => {
      const width = slideWidth();
      const index = Math.round(track.scrollLeft / width);
      if (index <= 0) {
        jumpTo(realCount, false);
      } else if (index >= realCount + 1) {
        jumpTo(1, false);
      } else {
        active = index;
      }
    };

    const scheduleNormalize = (delay = 150) => {
      clearTimeout(scrollTimer);
      clearTimeout(settleTimer);
      scrollTimer = window.setTimeout(() => {
        if (isInteracting) return;
        normalize();
        settleTimer = window.setTimeout(() => {
          if (!isInteracting) normalize();
        }, 220);
      }, delay);
    };

    requestAnimationFrame(() => jumpTo(1, false));

    track.addEventListener('scroll', () => {
      scheduleNormalize(160);
    }, { passive: true });

    const startInteraction = () => {
      isInteracting = true;
      clearTimeout(scrollTimer);
      clearTimeout(settleTimer);
    };
    const endInteraction = () => {
      isInteracting = false;
      scheduleNormalize(180);
    };

    track.addEventListener('scrollend', () => {
      if (!isInteracting) normalize();
    });
    track.addEventListener('pointerdown', startInteraction, { passive: true });
    track.addEventListener('pointerup', endInteraction, { passive: true });
    track.addEventListener('pointercancel', endInteraction, { passive: true });
    track.addEventListener('touchstart', startInteraction, { passive: true });
    track.addEventListener('touchend', endInteraction, { passive: true });
    track.addEventListener('touchcancel', endInteraction, { passive: true });

    window.addEventListener('resize', () => jumpTo(active, false));
  });

  /* PDP image magnifier */
  document.querySelectorAll('[data-pdp-magnifier]').forEach((modal) => {
    if (modal.dataset.ready === 'true') return;
    modal.dataset.ready = 'true';

    const section = modal.closest('.conversion-pdp');
    const image = modal.querySelector('[data-pdp-magnifier-image]');
    const stage = modal.querySelector('[data-pdp-magnifier-stage]');
    const close = modal.querySelector('[data-pdp-magnifier-close]');
    const zoomIn = modal.querySelector('[data-pdp-magnifier-zoom-in]');
    const zoomOut = modal.querySelector('[data-pdp-magnifier-zoom-out]');
    let scale = 1;
    let x = 0;
    let y = 0;
    let startX = 0;
    let startY = 0;
    let baseX = 0;
    let baseY = 0;
    let dragging = false;

    const applyTransform = () => {
      if (!image) return;
      image.style.setProperty('--pdp-zoom-scale', String(scale));
      image.style.setProperty('--pdp-zoom-x', x + 'px');
      image.style.setProperty('--pdp-zoom-y', y + 'px');
    };

    const resetZoom = () => {
      scale = 1;
      x = 0;
      y = 0;
      applyTransform();
    };

    const setScale = (nextScale) => {
      scale = Math.max(1, Math.min(4, Number(nextScale.toFixed(2))));
      if (scale === 1) {
        x = 0;
        y = 0;
      }
      applyTransform();
    };

    const openMagnifier = (trigger) => {
      if (!image || !trigger) return;
      const fallbackImage = trigger.querySelector('img');
      image.src = trigger.dataset.pdpMagnifierSrc || fallbackImage?.currentSrc || fallbackImage?.src || '';
      image.alt = trigger.dataset.pdpMagnifierAlt || fallbackImage?.alt || '';
      resetZoom();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      close?.focus();
    };

    const closeMagnifier = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      if (image) image.removeAttribute('src');
      document.body.style.overflow = '';
      resetZoom();
    };

    section?.querySelectorAll('[data-pdp-magnifier-open]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        openMagnifier(trigger);
      });
    });

    close?.addEventListener('click', closeMagnifier);
    zoomIn?.addEventListener('click', () => setScale(scale + 0.5));
    zoomOut?.addEventListener('click', () => setScale(scale - 0.5));

    stage?.addEventListener('wheel', (event) => {
      event.preventDefault();
      setScale(scale + (event.deltaY < 0 ? 0.25 : -0.25));
    }, { passive: false });

    stage?.addEventListener('dblclick', () => {
      setScale(scale > 1 ? 1 : 2);
    });

    stage?.addEventListener('pointerdown', (event) => {
      if (scale <= 1) return;
      dragging = true;
      stage.classList.add('is-dragging');
      stage.setPointerCapture(event.pointerId);
      startX = event.clientX;
      startY = event.clientY;
      baseX = x;
      baseY = y;
    });

    stage?.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      x = baseX + event.clientX - startX;
      y = baseY + event.clientY - startY;
      applyTransform();
    });

    const stopDragging = (event) => {
      if (!dragging) return;
      dragging = false;
      stage?.classList.remove('is-dragging');
      try {
        stage?.releasePointerCapture(event.pointerId);
      } catch (_) {}
    };

    stage?.addEventListener('pointerup', stopDragging);
    stage?.addEventListener('pointercancel', stopDragging);

    document.addEventListener('keydown', (event) => {
      if (!modal.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeMagnifier();
      if (event.key === '+' || event.key === '=') setScale(scale + 0.5);
      if (event.key === '-') setScale(scale - 0.5);
    });
  });

  /* Add-to-cart with drawer reveal + button success animation */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form], .product-form, .showcase-actions');
    if (!form) return;
    e.preventDefault();
    const submitter = e.submitter || form.querySelector('button[type=submit]');
    const isBuyNow = submitter && submitter.matches('[data-buy-now]');
    const originalLabel = submitter ? submitter.innerHTML : '';
    if (submitter) {
      submitter.classList.add('is-busy');
      submitter.disabled = true;
    }
    const fd = new FormData(form);
    if (submitter && submitter.name && !fd.has(submitter.name)) fd.append(submitter.name, submitter.value || '');
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
      if (!r.ok) throw new Error('add failed');
      const cart = await fetch('/cart.js').then(x => x.json());
      setCartCount(cart);
      try {
        await refreshCartDrawer();
      } catch(_) {}
      if (submitter) {
        submitter.classList.remove('is-busy');
        submitter.classList.add('is-success');
        submitter.innerHTML = 'Added';
      }
      if (isBuyNow) {
        setTimeout(() => { window.location.href = '/checkout'; }, 350);
      } else {
        openDrawer('CartDrawer');
        setTimeout(() => {
          if (!submitter) return;
          submitter.classList.remove('is-success');
          submitter.disabled = false;
          submitter.innerHTML = originalLabel;
        }, 1600);
      }
    } catch (err) {
      if (submitter) { submitter.classList.remove('is-busy'); submitter.disabled = false; }
      form.submit();
    }
  });

  /* Floating subscribe - dismissable + persisted */
  const sub = document.querySelector('[data-float-subscribe]');
  if (sub) {
    if (localStorage.getItem('gb-sub-dismissed') === '1') sub.hidden = true;
    sub.querySelector('[data-float-close]')?.addEventListener('click', (e) => {
      e.preventDefault(); e.stopPropagation();
      sub.hidden = true; localStorage.setItem('gb-sub-dismissed', '1');
    });
  }

  /* Reveal */
  const io = new IntersectionObserver((entries) => {
    entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -10% 0px' });
  document.querySelectorAll('.story, .testimonial, .spec, .card, .feature').forEach(el => { el.classList.add('reveal'); io.observe(el); });

  /* PDP carousel - center image highlighted, right images fade out */
  document.querySelectorAll('[data-pdp-carousel]').forEach((carousel) => {
    const imgs = carousel.querySelectorAll('[data-pdp-img]');
    const nextBtn = carousel.querySelector('[data-pdp-next]');
    if (!imgs.length) return;
    let active = 0;

    function paint() {
      imgs.forEach((img, i) => {
        const rel = i - active;                // negative = went left, 0 = center, positive = right
        // Center anchor: 50% horizontally. Each slot offsets by 22vw.
        const offset = rel === 0 ? '0vw' : (rel * 22) + 'vw';
        const scale  = rel === 0 ? 1 : Math.max(0.62, 1 - Math.abs(rel) * 0.12);
        const alpha  = rel === 0 ? 1 : Math.max(0,    1 - Math.abs(rel) * 0.45);
        // Cards moving LEFT (rel < 0) slide far left so the dark info panel covers them.
        const slideOff = rel < 0 ? -40 : 0;     // additional vw push for outgoing-left
        img.style.transform = 'translate(calc(-50% + ' + offset + ' + ' + slideOff + 'vw), -50%) scale(' + scale + ')';
        img.style.opacity   = String(alpha);
        img.style.zIndex    = String(20 - Math.abs(rel));
        img.style.pointerEvents = rel === 0 ? 'auto' : 'none';
      });
    }

    nextBtn?.addEventListener('click', () => {
      active = (active + 1) % imgs.length;
      paint();
    });

    // Keyboard
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { active = (active + 1) % imgs.length; paint(); }
      if (e.key === 'ArrowLeft')  { active = (active - 1 + imgs.length) % imgs.length; paint(); }
    });

    paint();
  });

  /* Showcase card stack - z-stacked at same position, scroll fades top card up */
  document.querySelectorAll('[data-card-stack]').forEach((stack) => {
    const cards = stack.querySelectorAll('[data-card]');
    if (!cards.length) return;
    const N = cards.length;
    const isDesktop = () => window.matchMedia('(min-width: 1101px)').matches;

    const reset = () => cards.forEach(c => { c.style.transform = ''; c.style.opacity = ''; });

    const update = () => {
      if (!isDesktop()) { reset(); return; }
      const r = stack.getBoundingClientRect();
      const totalScroll = Math.max(1, r.height - window.innerHeight);
      const scrolled = Math.max(0, Math.min(totalScroll, -r.top));
      const per = totalScroll / N;
      cards.forEach((card, i) => {
        const p = Math.max(0, Math.min(1, (scrolled - i * per) / per));
        if (p <= 0) {
          card.style.transform = '';
        } else {
          // outgoing card slides up; opacity stays constant
          const ty = -p * 90;          // vh - translates fully out of view
          const sc = 1 - p * 0.04;
          card.style.transform = 'translateY(' + ty + 'vh) scale(' + sc + ')';
        }
        card.style.opacity = '1';
      });
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { update(); ticking = false; });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
